export const LLM_PROVIDERS = ['bedrock', 'openai', 'anthropic', 'gemini', 'groq'];

export const STT_PROVIDERS = ['deepgram'];

export const TTS_PROVIDERS = ['cartesia', 'elevenlabs'];

export const VOICE_LOCALE_KEYS = ['ES', 'CA', 'EN', 'PT', 'ES_CA'];

export const VOICE_GENDERS = ['female', 'male', 'neutral'];
